module.exports = __webpack_public_path__ + "static/media/funnel-chart.557442c7.svg";